type SessionExpiredHandler = () => void

const handlers = new Set<SessionExpiredHandler>()
const COOLDOWN_MS = 30_000
let lastTriggeredAt = 0

export const registerSessionExpiredHandler = (handler: SessionExpiredHandler) => {
    handlers.add(handler)
    return () => {
        handlers.delete(handler)
    }
}

export const notifySessionExpired = () => {
    if (typeof window === 'undefined') return
    const now = Date.now()
    if (now - lastTriggeredAt < COOLDOWN_MS) return
    lastTriggeredAt = now
    handlers.forEach(handler => {
        try {
            handler()
        } catch {
            // ignore handler errors to avoid blocking others
        }
    })
}
